import React, { FunctionComponent } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import Image from '../BaseComponents/Image'
import BodyFont from '../Theme/Fonts/Body'
import BigButton from '../BaseComponents/Button/Standard/Big'
import BasicText from '../Theme/Fonts/BasicText'
import { RequireAtLeastOne } from '../utils/types/requireAtLeastOne'

export type Props = {
    /** headline of the PopUp */
    headline: string
    /**text placed under the image if exists if not then under the headline*/
    text: string
    /** alternate text for image */
    imageAlt?: string
    /** the url of the image */
    imageUrl?: string
    /** image width*/
    imageWidth?: string | number
    /** image height could be a string or a number*/
    imageHeight?: string | number
    /** the text in the middle of the button**
     * @defaultValue "ZUR STARTSEITE"
     */
    buttonText?: string
    /** href string to navigate to the provided url (web only) */
    buttonHref?: string
    /** callback when the user pressed on the button
     * @TJS-type function
     */
    onPressButton?: () => void
    /** callback when the user pressed on the fontello close icon
     * @TJS-type function
     */
    onPressClose: () => void
}
export type PopUpProps = RequireAtLeastOne<Props, 'onPressButton' | 'buttonHref'>

const PopUp: FunctionComponent<PopUpProps> = ({
    headline,
    text,
    imageAlt,
    imageUrl,
    imageWidth,
    imageHeight,
    buttonText = 'ZUR STARTSEITE',
    buttonHref,
    onPressButton,
    onPressClose,
}) => {
    return (
        <Grid
            backgroundColor="pearl"
            borderRadius={3}
            noExpand
            centerHorizontal
            elevation={5}
            padding={7}
            position="relative"
        >
            <Grid right={0} top={0} noExpand position="absolute">
                <Touchable onPress={onPressClose}>
                    <Grid margin={4} noExpand>
                        <FontelloIcon name="close-x" fontSize={12} color="onyx" />
                    </Grid>
                </Touchable>
            </Grid>
            <Grid marginBottom={5}>
                <BasicText
                    textAlign="center"
                    bold
                    lineHeight="LH30"
                    fontSize="FS28"
                    color="onyx"
                    numberOfLines={2}
                >
                    {headline}
                </BasicText>
            </Grid>
            {imageUrl ? (
                <Grid marginBottom={5} noExpand>
                    <Image
                        aspectRatio="16:9"
                        alt={imageAlt}
                        imageUrl={imageUrl}
                        width={imageWidth}
                        height={imageHeight}
                        size="M"
                    />
                </Grid>
            ) : null}
            <Grid noExpand marginBottom={5} width={imageWidth}>
                <BodyFont textAlign="center" color="onyx-5">
                    {text}
                </BodyFont>
            </Grid>
            <BigButton backgroundColor="onyx-3" href={buttonHref} onPress={onPressButton}>
                {buttonText}
            </BigButton>
        </Grid>
    )
}

export default PopUp
